import type { SummaryCardFieldMapping, SummaryCardRow } from '../../../summary/summaryCardSourceTypes';
import type { RequestFieldDefinition } from '../types';
import {
  buildSummaryFieldMappingsFromRows,
  buildSummaryRowsFromFields,
  enrichSummaryRowsWithRbac,
} from './summaryRows';

export type StepSummaryBridge = {
  getSummaryDefinitions: () => ReadonlyArray<SummaryCardRow>;
  getSummaryFieldMappings: () => ReadonlyArray<SummaryCardFieldMapping>;
  getSummaryRowTestIdsInOrder: (rowTestIdPrefix: string) => string[];
};

export function createStepSummaryBridge(
  fields: readonly RequestFieldDefinition[],
): StepSummaryBridge {
  const registryRows = buildSummaryRowsFromFields(fields);
  const enriched = enrichSummaryRowsWithRbac(registryRows);

  return {
    getSummaryDefinitions: () => enriched,
    getSummaryFieldMappings: () => buildSummaryFieldMappingsFromRows(enriched),
    getSummaryRowTestIdsInOrder: (rowTestIdPrefix: string) =>
      enriched.map((d) => `${rowTestIdPrefix}${d.dataField}`),
  };
}
